import createAPIRequestId from '../helpers/createAPIRequestId'
import store from '../store/index'

export default async function useEditCharacterArmourLocation(armourLocation) {
  const request = createAPIRequestId({
    endpoint: 'api/v1/character-armour-locations/',
    partialInd: true,
    id: armourLocation.id,
  })

  return store.dispatch('characters/editCharacterArmourLocation', {
    api_request: request,
    payload: armourLocation.payload,
  })
}
